import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
import store from '../store'

Vue.filter('ymday', function (dataStr, pattern = 'YYYY-MM-DD') {
  if (!isNaN(dataStr)) {
    dataStr = parseInt(dataStr)
  }
  return moment(dataStr).format(pattern)
})

Vue.filter('cnComplaintStatusName', function (tp) {
  let arr = [
    '未解决',
    '解决中',
    '已回复',
    '需完善',
    '已结束',
  ]
  return arr[tp - 1]
})

Vue.filter('twComplaintStatusName', function (tp) {
  let arr = [
    '未解决',
    '解决中',
    '已回復',
    '需完善',
    '已結束',
  ]
  return arr[tp - 1]
})

Vue.filter('payStateName', function (val) {
  var index = store.state.home.payState.findIndex(item => {
    if (item.id === val) {
      return item
    }
  })
  if (index >= 0) {
    return store.state.home.payState[index].name
  } else {
    return val
  }
})
